module.exports = __webpack_public_path__ + "static/media/thumbnail-calories@2x.08092703.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/GymTvThumbnails/thumbnail-calories@2x.png
// module id = 1083
// module chunks = 2